/**
 * UI strings are addressed by key from day one. Ukrainian is the base locale.
 * One file per screen family in ./uk; this index only spreads them. Add a new file and one
 * import line here instead of editing another block's file (keeps parallel work conflict-free).
 * Keys are flat and namespaced by screen; never put user-facing text in components.
 */
import { agents } from './uk/agents';
import { approvals } from './uk/approvals';
import { businesses } from './uk/businesses';
import { connect } from './uk/connect';
import { core } from './uk/core';
import { dialogs } from './uk/dialogs';
import { inbox } from './uk/inbox';
import { knowledge } from './uk/knowledge';
import { overview } from './uk/overview';
import { tasks } from './uk/tasks';
import { external } from './uk/external';
import { audit } from './uk/audit';
import { processes } from './uk/processes';
import { runs } from './uk/runs';
import { skillAgents } from './uk/skillAgents';
import { telegram } from './uk/telegram';

export const uk = {
  ...core,
  ...agents,
  ...approvals,
  ...businesses,
  ...connect,
  ...dialogs,
  ...inbox,
  ...knowledge,
  ...overview,
  ...tasks,
  ...external,
  ...audit,
  ...processes,
  ...runs,
  ...skillAgents,
  ...telegram,
} as const;

export type I18nKey = keyof typeof uk;
